import React, { useContext } from 'react'
import { ContentHeader } from '../../layout/Content'
import { invoiceControllerContext } from './InvoiceController'
import InvoiceHeaderStyle from './css/InvoiceHeaderStyle'

function InvoiceHeader() {
  const invoiceController = useContext(invoiceControllerContext)
  const timerDisplay = invoiceController.timerDisplay[0]
  return (
    <ContentHeader>
      <div className='content-header-content'>
        <div className='header-title caption'>
          Sales Invoice
        </div>
        <div className='invoice-sesson-timer-container'>
          <div id='invoice-session-timer' style={{display: (timerDisplay) ? 'inline-block' : 'none'}}>{timerDisplay}</div>
        </div>
      </div>
      <InvoiceHeaderStyle />
    </ContentHeader>
  )
}

export default React.memo(InvoiceHeader)
